export default __webpack_public_path__ + "static/media/Flag_of_Slovakia.ed0c4e50.svg";